var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 380.9 84.8",
    style: {
      enableBackground: "new 0 0 380.9 84.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFF;}\n\t.st1{fill:red;}\n\t.st2{fill:#FFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.9,13.2c-1.4-5.2-5.5-9.3-10.7-10.7C98.7,0,60.7,0,60.7,0s-38,0-47.5,2.5C8,3.9,3.9,8,2.5,13.2 C0,22.7,0,42.4,0,42.4s0,19.8,2.5,29.2c1.4,5.2,5.5,9.3,10.7,10.7c9.5,2.5,47.5,2.5,47.5,2.5s38,0,47.5-2.5 c5.2-1.4,9.3-5.5,10.7-10.7c2.5-9.5,2.5-29.2,2.5-29.2S121.4,22.7,118.9,13.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "48.5,60.7 80.1,42.5 48.5,24.2  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176.3,77.3c-2.4-1.6-4.1-4.1-5.1-7.6c-1-3.4-1.5-8-1.5-13.6v-7.7c0-5.7,0.6-10.3,1.7-13.8 c1.2-3.5,3-6,5.4-7.6c2.5-1.6,5.7-2.4,9.7-2.4c3.9,0,7.1,0.8,9.5,2.4s4.1,4.2,5.2,7.6s1.7,8,1.7,13.8v7.7c0,5.7-0.5,10.2-1.6,13.7 c-1.1,3.4-2.8,6-5.2,7.6c-2.4,1.6-5.7,2.4-9.8,2.4C182,79.7,178.7,78.9,176.3,77.3z M189.8,69c0.7-1.7,1-4.6,1-8.5V43.9 c0-3.8-0.3-6.6-1-8.4s-1.8-2.6-3.5-2.6c-1.6,0-2.8,0.9-3.4,2.6c-0.7,1.8-1,4.6-1,8.4v16.6c0,3.9,0.3,6.8,1,8.5 c0.6,1.7,1.8,2.6,3.5,2.6C187.9,71.6,189.1,70.7,189.8,69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M360.8,56.2v2.7c0,3.4,0.1,6,0.3,7.7c0.2,1.7,0.6,3,1.3,3.7c0.6,0.8,1.6,1.2,3,1.2c1.8,0,3-0.7,3.7-2.1 c0.7-1.4,1-3.7,1.1-7l10.3,0.6c0.1,0.5,0.1,1.1,0.1,1.9c0,4.9-1.3,8.6-4,11s-6.5,3.6-11.4,3.6c-5.9,0-10-1.9-12.4-5.6 c-2.4-3.7-3.6-9.4-3.6-17.2v-9.3c0-8,1.2-13.8,3.7-17.5s6.7-5.5,12.6-5.5c4.1,0,7.3,0.8,9.5,2.3s3.7,3.9,4.6,7 c0.9,3.2,1.3,7.6,1.3,13.2V56h-20.1V56.2z M362.3,33.8c-0.6,0.8-1,2-1.2,3.7s-0.3,4.3-0.3,7.8v3.8h8.8v-3.8c0-3.4-0.1-6-0.3-7.8 c-0.2-1.8-0.7-3-1.3-3.7c-0.6-0.7-1.6-1.1-2.8-1.1C363.9,32.7,362.9,33.1,362.3,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.1,55.2L133.5,5.9h11.9l4.8,22.3c1.2,5.5,2.1,10.2,2.7,14.1h0.3c0.4-2.8,1.3-7.4,2.7-14l5-22.4h11.9 L159,55.2v23.7h-11.8L147.1,55.2L147.1,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.5,25.6v53.3h-9.4l-1-6.5h-0.3c-2.5,4.9-6.4,7.4-11.5,7.4c-3.5,0-6.1-1.2-7.8-3.5 c-1.7-2.3-2.5-5.9-2.5-10.9V25.6h12v39.1c0,2.4,0.3,4.1,0.8,5.1s1.4,1.5,2.6,1.5c1,0,2-0.3,3-1c1-0.6,1.7-1.4,2.1-2.4V25.6H241.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303,25.6v53.3h-9.4l-1-6.5h-0.3c-2.5,4.9-6.4,7.4-11.5,7.4c-3.5,0-6.1-1.2-7.8-3.5 c-1.7-2.3-2.5-5.9-2.5-10.9V25.6h12v39.1c0,2.4,0.3,4.1,0.8,5.1s1.4,1.5,2.6,1.5c1,0,2-0.3,3-1c1-0.6,1.7-1.4,2.1-2.4V25.6H303z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M274.1,15.6h-11.9v63.3h-11.7V15.7h-11.9V6.1h35.5V15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M342.7,34.1c-0.7-3.4-1.9-5.8-3.5-7.3s-3.9-2.3-6.7-2.3c-2.2,0-4.3,0.6-6.2,1.9c-1.9,1.2-3.4,2.9-4.4,4.9 h-0.1V3.2h-11.6v75.7h9.9l1.2-5h0.3c0.9,1.8,2.3,3.2,4.2,4.3c1.9,1,3.9,1.6,6.2,1.6c4.1,0,7-1.9,8.9-5.6c1.9-3.7,2.9-9.6,2.9-17.5 v-8.4C343.8,42.1,343.4,37.5,342.7,34.1z M331.7,55.8c0,3.9-0.2,6.9-0.5,9.1c-0.3,2.2-0.9,3.8-1.6,4.7c-0.8,0.9-1.8,1.4-3,1.4 c-1,0-1.9-0.2-2.7-0.7c-0.8-0.5-1.5-1.2-2-2.1V38c0.4-1.4,1.1-2.6,2.1-3.6c1-0.9,2.1-1.4,3.2-1.4c1.2,0,2.2,0.5,2.8,1.4 c0.7,1,1.1,2.6,1.4,4.8c0.3,2.3,0.4,5.5,0.4,9.6L331.7,55.8L331.7,55.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.ade1f5b6728a81aaa4025345b847a5cd.svg";
export { ForwardRef as ReactComponent };